// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"4d5cace9","977":"2cf95034"}[chunkId] + ".chunk.js";
};